import { useCallback } from 'react';
import { useCurrentLanguage } from '@app/i18n';
import trimStart from 'lodash/trimStart';
import trimEnd from 'lodash/trimEnd';

/**
 * Builds a url with consideration of current language.
 *
 * const buildUrl = useUrlBuilder()
 * const url = buildUrl('any-path');
 */
const useUrlBuilder = () => {
  const { urlPrefix } = useCurrentLanguage();

  return useCallback(
    (pathname: string): string => {
      const url = trimEnd(`${urlPrefix}${trimStart(pathname, '/')}`, '/');

      if (!url) {
        return '/';
      }

      return url;
    },
    [urlPrefix],
  );
};

export default useUrlBuilder;
